module.exports = __webpack_public_path__ + "img/light.c6e93f3c.png";